import { Injectable } from '@angular/core';
import { PersistedSessionRecord } from './auth.models';

const SESSION_STORAGE_KEY = 'wm-session';
const DEVICE_UUID_STORAGE_KEY = 'wm-device-uuid';

@Injectable({ providedIn: 'root' })
export class AuthStorageService {
  readSession(): PersistedSessionRecord | null {
    const rawValue = localStorage.getItem(SESSION_STORAGE_KEY);

    if (!rawValue) {
      return null;
    }

    try {
      const parsed = JSON.parse(rawValue) as Partial<PersistedSessionRecord>;

      if (!parsed.authToken || !parsed.userId || !parsed.restoredAt) {
        this.clearSession();
        return null;
      }

      return {
        authToken: parsed.authToken,
        userId: parsed.userId,
        operatorLabel: parsed.operatorLabel ?? null,
        restoredAt: parsed.restoredAt
      };
    } catch {
      this.clearSession();
      return null;
    }
  }

  writeSession(record: PersistedSessionRecord): void {
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(record));
  }

  clearSession(): void {
    localStorage.removeItem(SESSION_STORAGE_KEY);
  }

  readOrCreateDeviceUuid(): string {
    const existingUuid = localStorage.getItem(DEVICE_UUID_STORAGE_KEY);

    if (existingUuid) {
      return existingUuid;
    }

    const nextUuid = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`;
    localStorage.setItem(DEVICE_UUID_STORAGE_KEY, nextUuid);
    return nextUuid;
  }
}
